//民宿管理
export default [{
  path: '/busStatement',
  component: () =>
    import('../pages/statementManage/busStatement.vue'),
  name: 'busStatement',
  title: "班车收入报表",
  meta: {
    title: "班车收入报表"
  }
}, {
  path: '/shopStatement',
  component: () =>
    import('../pages/statementManage/shopStatement.vue'),
  name: 'shopStatement',
  title: "商城分析报表",
  meta: {
    title: "商城分析报表"
  }
}, {
  path: '/userConsumeStatement',
  component: () =>
    import('../pages/statementManage/userConsumeStatement.vue'),
  name: 'userConsumeStatement',
  title: "用户消费报表",
  meta: {
    title: "用户消费报表"
  }
}, {
  path: '/activityJionStatement',
  component: () =>
    import('../pages/statementManage/activityJionStatement.vue'),
  name: 'activityJionStatement',
  title: "活动参与报表",
  meta: {
    title: "活动参与报表"
  }
}, {
  path: '/takeOutStatement',
  component: () =>
    import('../pages/statementManage/takeOutStatement.vue'),
  name: 'takeOutStatement',
  title: "外卖报表",
  meta: {
    title: "外卖报表"
  }
}, {
  path: '/rechargeDetailsStatement',
  component: () =>
    import('../pages/statementManage/rechargeDetailsStatement.vue'),
  name: 'rechargeDetailsStatement',
  title: "钱包收支表",
  meta: {
    title: "钱包收支表"
  }
}, {
  path: '/dailyIncomeStatement',
  component: () =>
    import('../pages/statementManage/dailyIncomeStatement.vue'),
  name: 'dailyIncomeStatement',
  title: "每日收入报表",
  meta: {
    title: "每日收入报表"
  }
}, {
  path: '/dailyRechargeWithdrawStatement',
  component: () =>
    import('../pages/statementManage/dailyRechargeWithdrawStatement.vue'),
  name: 'dailyRechargeWithdrawStatement',
  title: "每日充值提现报表",
  meta: {
    title: "每日充值提现报表"
  }
}, {
  path: '/couponWithdrawStatement',
  component: () =>
    import('../pages/statementManage/couponWithdrawStatement.vue'),
  name: 'couponWithdrawStatement',
  title: "卡券核销报表",
  meta: {
    title: "卡券核销报表"
  }
}, {
  path: '/userAnalyseStatement',
  component: () =>
    import('../pages/statementManage/userAnalyseStatement.vue'),
  name: 'userAnalyseStatement',
  title: "客户分析",
  meta: {
    title: "客户分析"
  }
}, {
  path: '/trajectoryAnalysis',
  component: () =>
    import('../pages/statementManage/trajectoryAnalysis.vue'),
  name: '业主在住分析',
  title: "业主在住分析",
  meta: {
    title: "业主在住分析"
  }
},
  {
    path: '/restQrcodeStatement',
    component: () =>
      import('../pages/statementManage/restQrcodeStatement.vue'),
    name: 'restQrcodeStatement',
    title: "餐厅扫码日报",
    meta: {
      title: "餐厅扫码日报"
    }
  }, {
    path: '/plateDailyStatement',
    component: () =>
      import('../pages/statementManage/plateOrderDailyStatement.vue'),
    name: 'plateDailyStatement',
    title: "停车缴费日报",
    meta: {
      title: "停车缴费日报"
    }
  }, {
    path: '/userGrowthStatement',
    component: () =>
      import('../pages/statementManage/userGrowthStatement.vue'),
    name: 'userGrowthStatement',
    title: "会员来源表",
    meta: {
      title: "会员来源表"
    }
  }, {
    path: '/activeStatement',
    component: () =>
      import('../pages/statementManage/activeStatement.vue'),
    name: 'activeStatement',
    title: "活动收入报表",
    meta: {
      title: "活动收入报表"
    }
  }, {
    path: '/stayStatement',
    component: () =>
      import('../pages/statementManage/stayStatement.vue'),
    name: 'stayStatement',
    title: "住宿收入报表",
    meta: {
      title: "住宿收入报表"
    }
  }, {
    path: '/minsuDetailStatement',
    component: () =>
      import('../pages/statementManage/minsuDetailStatement.vue'),
    name: 'minsuDetailStatement',
    title: "民宿详情报表",
    meta: {
      title: "民宿详情报表"
    }
  }, {
    path: '/hotelDetailStatement',
    component: () =>
      import('../pages/statementManage/hotelDetailStatement.vue'),
    name: 'hotelDetailStatement',
    title: "酒店详情报表",
    meta: {
      title: "酒店详情报表"
    }
  }, {
    path: '/hotelSaleStatement',
    component: () =>
      import('../pages/statementManage/hotelSaleStatement.vue'),
    name: 'hotelSaleStatement',
    title: "酒店房型销售报表",
    meta: {
      title: "酒店房型销售报表"
    }
  }, {
    path: '/rechargeStatement',
    component: () =>
      import('../pages/statementManage/rechargeStatement.vue'),
    name: 'rechargeStatement',
    title: "会员卡充值提现报表",
    meta: {
      title: "会员卡充值提现报表"
    }
  }, {
    path: '/plateOrderStatement',
    component: () =>
      import('../pages/statementManage/plateOrderStatement.vue'),
    name: 'plateOrderStatement',
    title: "停车场收入表",
    meta: {
      title: "停车场收入表"
    }
  }, {
    path: '/restScenCodeStatement',
    component: () =>
      import('../pages/statementManage/restScenCodeStatement.vue'),
    name: 'restScenCodeStatement',
    title: "扫码点餐日报汇总报表",
    meta: {
      title: "扫码点餐日报汇总报表"
    }
  }, {
    path: '/couponIssueStatement',
    component: () =>
      import('../pages/statementManage/couponIssueStatement.vue'),
    name: 'couponIssueStatement',
    title: "未发优惠券报表",
    meta: {
      title: "未发优惠券报表"
    }
  }, {
    path: '/ticketsOrderStatement',
    component: () =>
      import('../pages/statementManage/ticketsOrderStatement.vue'),
    name: 'ticketsOrderStatement',
    title: "门票收入报表",
    meta: {
      title: "门票收入报表"
    }
  }, {
    path: '/goodsSaleStatement',
    component: () =>
      import('../pages/statementManage/goodsSaleStatement.vue'),
    name: 'goodsSaleStatement',
    title: "商城商品销售",
    meta: {
      title: "商城商品销售"
    }
  }, {
    path: '/saleTotalStatement',
    component: () =>
      import('../pages/statementManage/saleTotalStatement.vue'),
    name: 'saleTotalStatement',
    title: "商品销售汇总表",
    meta: {
      title: "商品销售汇总表"
    }
  }, {
    path: '/goodsSaleDetailsStatement',
    component: () =>
      import('../pages/statementManage/goodsSaleDetailsStatement.vue'),
    name: 'goodsSaleDetailsStatement',
    title: "商品销售明细表",
    meta: {
      title: "商品销售明细表"
    }
  }, {
    path: '/scanTradeDetailReport',
    component: () =>
      import('../pages/statementManage/scanTradeDetailReport.vue'),
    name: 'scanTradeDetailReport',
    title: "联营收入明细表",
    meta: {
      title: "联营收入明细表"
    }
  }, {
    path: '/scanTradeStatement',
    component: () =>
      import('../pages/statementManage/scanTradeStatement.vue'),
    name: 'scanTradeStatement',
    title: "联营收入汇总表",
    meta: {
      title: "联营收入汇总表"
    }
  }, {
    path: '/purchaseInReportStatement',
    component: () =>
      import('../pages/statementManage/purchaseInReportStatement.vue'),
    name: 'purchaseInReportStatement',
    title: "入库明细表",
    meta: {
      title: "入库明细表"
    }
  }, {
    path: '/inventoryStatement',
    component: () =>
      import('../pages/statementManage/inventoryStatement.vue'),
    name: 'inventoryStatement',
    title: "库存流水报表",
    meta: {
      title: "库存流水报表"
    }
  }, {
    path: '/inventoryCheckReport',
    component: () =>
      import('../pages/statementManage/inventoryCheckReport.vue'),
    name: 'inventoryCheckReport',
    title: "商品库存表",
    meta: {
      title: "商品库存表"
    }
  },
  {
    path: '/inventoryCheckHistoryReport',
    component: () =>
      import('../pages/statementManage/inventoryCheckHistoryReport.vue'),
    name: 'inventoryCheckHistoryReport',
    title: "历史库存表",
    meta: {
      title: "历史库存表"
    }
  },
  {
    path: '/payTypeReport',
    component: () =>
      import('../pages/statementManage/payTypeReport.vue'),
    name: 'payTypeReport',
    title: "商品收款方式汇总",
    meta: {
      title: "商品收款方式汇总"
    }
  },
  {
    path: '/inventoryInOutPriceReport',
    component: () =>
      import('../pages/statementManage/inventoryInOutPriceLast.vue'),
    name: 'inventoryInOutPriceReport',
    title: "库存进销存报表",
    meta: {
      title: "库存进销存报表"
    }
  },
  {
    path: '/inventoryInOutPriceReportO',
    component: () =>
      import('../pages/statementManage/inventoryInOutPrice.vue'),
    name: 'inventoryInOutPriceReportO',
    title: "进销存出库成本表",
    meta: {
      title: "进销存出库成本表"
    }
  },
  {
    path: '/productCategorySaleReport',
    component: () =>
      import('../pages/statementManage/saleGoodsCateReport.vue'),
    name: 'productCategorySaleReport',
    title: "商品销售报表(分类)",
    meta: {
      title: "商品销售报表(分类)"
    }
  },
  {
    path: '/vendorGoodsPurchaseStatement',
    component: () =>
      import('../pages/statementManage/vendorGoodsPurchaseStatement.vue'),
    name: 'vendorGoodsPurchaseStatement',
    title: "供应商供货报表",
    meta: {
      title: "供应商供货报表"
    }
  },
  {
    path: '/rentOrderStatement',
    component: () =>
      import('../pages/statementManage/rentOrderStatement.vue'),
    name: 'rentOrderStatement',
    title: "租赁订单报表",
    meta: {
      title: "租赁订单报表"
    }
  },
  {
    path: '/stockTotalStatement',
    component: () =>
      import('../pages/statementManage/stockTotalStatement.vue'),
    name: 'stockTotalStatement',
    title: "库存进销存明细报表",
    meta: {
      title: "库存进销存明细报表"
    }
  }

];
